import React from 'react';
import { Field } from 'formik';
import { pipe } from 'ramda';
import Input from './Input';

import { withLabel, withFormGroup, withError } from '../hocs';

const InputWithError = withError(Input);

const LabeledInput = pipe(
  withLabel,
  withFormGroup,
)(props => <Field {...props} component={InputWithError} />);


export default LabeledInput;


// WEBPACK FOOTER //
// ./src/components/formik/LabeledInput.jsx